// doc: https://product.hubteam.com/docs/superstore/index.html
import { createIndexedDBSuperstore, createSyncLocalSuperstore } from 'superstore';
let productUpdateIDB;
export const getProductUpdateIdxDB = async () => {
  if (!productUpdateIDB) {
    const idbStore = createIndexedDBSuperstore({
      namespace: 'productUpdates'
    });
    productUpdateIDB = await idbStore.open();
  }
  return productUpdateIDB;
};
let unprocessedPUIdLocalStorage;
export const getUnprocessedPUIdLocalStorage = userId => {
  if (!unprocessedPUIdLocalStorage) {
    // TODO: Does create sync local superstore use the namespace to check if that local storage existed?
    unprocessedPUIdLocalStorage = createSyncLocalSuperstore({
      namespace: `unprocessedMarkViewedPUIds-${userId}`
    });
  }
  return unprocessedPUIdLocalStorage;
};
let rateLimitLocalStorage;
export const getRateLimitLocalStorage = () => {
  if (!rateLimitLocalStorage) {
    rateLimitLocalStorage = createSyncLocalSuperstore({
      namespace: `feedbackRateLimit`
    });
  }
  return rateLimitLocalStorage;
};

// Not superstore
export const createLoggedUnknownProductsSessionStorage = () => {
  const namespace = 'pu-unknown-products';
  const getAllLoggedUnknownProducts = () => {
    const storedProducts = sessionStorage.getItem(namespace);
    if (!storedProducts) {
      return [];
    }
    return JSON.parse(storedProducts);
  };
  const checkUnknownProductLogSent = text => {
    const currentUnknownProducts = getAllLoggedUnknownProducts();
    return currentUnknownProducts.includes(text);
  };
  const setUnknownProductLogSent = text => {
    const loggedUnknownProducts = getAllLoggedUnknownProducts();
    let products = [];
    if (loggedUnknownProducts) {
      products = loggedUnknownProducts;
    }
    if (!products.includes(text)) {
      products.push(text);
      sessionStorage.setItem(namespace, JSON.stringify(products));
    }
  };
  return {
    checkUnknownProductLogSent,
    setUnknownProductLogSent
  };
};